module.exports = new __parcel__URL__("shop_all_button_inactive.4e69d9d5.png").toString();